/* FAQs are maintained in Shopify Pages > IKARAO Support: Heading 2 question, then answer. */
(() => {
  'use strict';
  const allowed = new Set(['P','BR','A','STRONG','EM','B','I','U','S','UL','OL','LI','H2','H3','H4','BLOCKQUOTE','TABLE','THEAD','TBODY','TR','TH','TD','IMG']);
  const blocked = 'script,style,iframe,object,embed,form,input,button,textarea,select,svg,math,template';
  const compact = value => String(value || '').replace(/\s+/g, ' ').trim();
  const safeUrl = (value, image = false) => {
    if (!compact(value)) return '';
    try {
      const url = new URL(value, window.location.href);
      return (image ? ['https:','http:'] : ['https:','http:','mailto:','tel:']).includes(url.protocol) ? url.href : '';
    } catch { return ''; }
  };
  function clean(source) {
    const container = document.createElement('div');
    container.append(source.cloneNode(true));
    container.querySelectorAll(blocked).forEach(el => el.remove());
    [...container.querySelectorAll('*')].reverse().forEach(el => {
      if (!allowed.has(el.tagName)) { el.replaceWith(...el.childNodes); return; }
      const href = el.tagName === 'A' ? safeUrl(el.getAttribute('href') || '') : '';
      const src = el.tagName === 'IMG' ? safeUrl(el.getAttribute('src') || '', true) : '';
      const alt = el.getAttribute('alt') || '';
      const listStart = el.tagName === 'OL' ? Number(el.getAttribute('start')) : 0;
      [...el.attributes].forEach(attribute => el.removeAttribute(attribute.name));
      if (href) { el.setAttribute('href', href); el.setAttribute('rel', 'noopener noreferrer'); }
      if (el.tagName === 'IMG') {
        if (!src) { el.remove(); return; }
        el.setAttribute('src', src); el.setAttribute('alt', alt); el.setAttribute('loading', 'lazy');
      }
      if (Number.isInteger(listStart) && listStart > 0) el.setAttribute('start', String(listStart));
    });
    return container;
  }
  function hash(value) {
    let result = 2166136261;
    for (const char of value.toLowerCase()) result = Math.imul(result ^ char.codePointAt(0), 16777619);
    return (result >>> 0).toString(36);
  }
  function readableText(element) {
    const copy = element.cloneNode(true);
    copy.querySelectorAll('br').forEach(node => node.replaceWith(document.createTextNode(' ')));
    copy.querySelectorAll('p,li,ul,ol,h2,h3,h4,blockquote,table,tr,td,th').forEach(node => node.append(document.createTextNode(' ')));
    return compact(copy.textContent);
  }
  function parse(template) {
    if (!template) return [];
    const content = clean(template.content || template);
    const heading = content.querySelector('h2') ? 'H2' : 'H3';
    [...content.querySelectorAll('blockquote')].reverse().forEach(node => {
      if (node.querySelector(heading.toLowerCase())) node.replaceWith(...node.childNodes);
    });
    const groups = []; let current = null;
    for (const node of [...content.childNodes]) {
      if (node.nodeType === 1 && node.tagName === heading) {
        current = { name: compact(node.textContent), answer: document.createElement('div') };
        groups.push(current);
      } else if (current) current.answer.append(node.cloneNode(true));
    }
    const used = new Map();
    return groups.filter(group => group.name && (compact(group.answer.textContent) || group.answer.querySelector('img'))).map(group => {
      const base = 'support-faq-' + hash(group.name);
      const duplicate = used.get(base) || 0; used.set(base, duplicate + 1);
      const id = duplicate ? `${base}-${duplicate + 1}` : base;
      const title = group.name.toLowerCase();
      const models = [];
      for (const [code, model] of [['x1','break-x1'],['x2','break-x2'],['s1','shell-s1'],['s2','shell-s2'],['s3','shell-s3'],['k1','sparkle-k1']]) {
        if (new RegExp(`\\b${code[0]}[ -]?${code[1]}\\b`, 'i').test(title)) models.push(model);
      }
      if (/\bmic\s*box\b/i.test(title)) models.push('micbox-pro');
      return { id, name: group.name, category: 'FAQ', type: 'faq', body: readableText(group.answer), html: group.answer.innerHTML, url: `#${id}`, models: models.length ? models : undefined };
    });
  }
  window.IKARAO_SUPPORT_FAQ = { parse };
})();
